import { useEffect } from 'react';
import { selectPortalId } from '../selectors/portal.selectors';
import { getPLPOExperienceThunk } from '../thunks/plpo-experience.thunk';
import { useAppDispatch, useAppSelector } from './index';
import { selectPLPOGroupKey, selectPLPOEligibility, selectPLPOProgress, selectIsFetchingPLPOExperience, selectHasPLPOError } from '../selectors/plpo-experience.selectors';
const usePLPOData = () => {
  const portalId = useAppSelector(selectPortalId);
  const dispatch = useAppDispatch();
  const groupKey = useAppSelector(selectPLPOGroupKey);
  const isEligible = useAppSelector(selectPLPOEligibility);
  const progress = useAppSelector(selectPLPOProgress);
  const isFetching = useAppSelector(selectIsFetchingPLPOExperience);
  const hasError = useAppSelector(selectHasPLPOError);
  useEffect(() => {
    void dispatch(getPLPOExperienceThunk(portalId));
  }, [dispatch, portalId]);
  return {
    groupKey,
    isEligible,
    progress,
    isFetching,
    hasError
  };
};
export default usePLPOData;